
<ng-template #content let-modal class="modal-backdrop fade show" role="dialog">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{headerTitle}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="col">
      <form [formGroup]="fgCredits" novalidate>
        <div class="row">
          <div class="col col-sm-6 col-md-12">
            <div class="row"  >
              <div class="col col-md-6">
          <div class="row"  *ngIf="mode=='A'">
            <div class="form-group col col-md-12 col-xs-12">
              <label class="control-label required" for="ibraSubregion">IBRA subregion</label>
              <span class="ml-2"><tooltip register="Common" tab="Credit Popup" section="Credit" field="IBRA subregion"></tooltip></span>

            <div>
              <ng-autocomplete #ibraAutoComplete [data]="autoCompleteSubregions"
                [searchKeyword]="'name'"
                placeholder="Search for IBRA subregion by name"
                (selected)='ibraSelected($event)'
                (inputChanged)='onChangeIBRASearch($event)'
                [itemTemplate]='ibraItemTemplate'
                [notFoundTemplate]='ibraNotFoundTemplate'>
              </ng-autocomplete>
              <div class="text-danger" *ngIf="fgCredits.controls.ibraSubregion.touched && fgCredits.controls.ibraSubregion.hasError('required')">
                <small>IBRA subregion is required.</small>
              </div>
              <div class="text-danger" *ngIf="fgCredits.controls.ibraSubregion.touched && fgCredits.controls.ibraSubregion.hasError('invalidSelection') && !(ibraKeyword && ibraKeyword.length >= 2 && autoCompleteSubregions && autoCompleteSubregions.length === 0)">
                <small>Please select a valid IBRA subregion from the dropdown list.</small>
              </div>
            </div>
            
            <ng-template #ibraItemTemplate let-item>
               <a [innerHTML]="item.name"></a>
            </ng-template>
            <ng-template #ibraNotFoundTemplate let-notFound>
              <div [innerHTML]="notFound"></div>
            </ng-template>
          </div>
        </div>
        <div class="row"  *ngIf="mode!='A'">
            <div class="form-group col col-md-12 col-xs-12">
              <label class="control-label" for="ibraSubregion">IBRA subregion</label>
              <input id="ibraSubregionText" formControlName="ibraSubregionText" [disabled]="true"  type="text" class="form-control"  />
            <div>
            </div>
          </div>
        </div>
         <div class="row">
                  <div class="form-group col col-md-12 col-xs-12">
                    <label class="control-label" for="ibraRegion">IBRA region:</label>
                    <label class="pl-2">{{" " + selectedIbraRegionName}}</label>
                  </div>
                </div>

             
                <div class="row">
                  <div class="form-group col col-md-12 col-xs-12">
                    <label class="control-label required" for="creditCategory">Credit category</label>
                    <span class="ml-2"><tooltip register="Common" tab="Credit Popup" section="Credit" field="Credit category"></tooltip></span>
                    <select id="creditCategory" formControlName="creditCategory" class="form-control" (change)="categoryChanged($event)">
                      <option value="">Select credit category</option>
                      <option value="Ecosystem">Ecosystem</option>
                      <option value="Species">Species</option>
                    </select>
                    <div class="text-danger" [hidden]="fgCredits.controls.creditCategory.valid || !fgCredits.controls.creditCategory.touched">
                      <small *ngIf="fgCredits.controls.creditCategory.hasError('required')">Credit category is required.</small>
                    </div>

                  </div>
                </div>
                <div class="row" *ngIf="mode=='A'">
                  <div class="form-group col col-md-12 col-xs-12">
                    <span class="control-label required">Search for credit</span>
                    <span class="ml-2"><tooltip register="Common" tab="Credit Popup" section="Credit" field="Search for credit"></tooltip></span>
                    <div>
                      <ng-autocomplete #autoComplete2 
                                      *ngIf="showCreditSearch"
                                      [data]="creditSearchResults"
                                       [searchKeyword]="keyword"
                                       placeholder="Search for a credit type id or name"
                                       (selected)='creditSelected($event)'
                                       (inputChanged)='onChangeSearch($event)'
                                       [itemTemplate]="itemTemplate2"
                                       [notFoundTemplate]="notFoundTemplate2">
                      </ng-autocomplete>

                      <ng-template #itemTemplate2 let-item>
                        <a [innerHTML]="formatCreditResult(item)"></a>
                      </ng-template>

                      <ng-template #notFoundTemplate2 let-notFound>
                        <div [innerHTML]="notFound"></div>
                      </ng-template>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col col-md-12 col-xs-12">
                    <label class="control-label " for="pct">Credit type ID number</label>
                    <div class="input-group"><input id="pct" formControlName="pct" title="PCT" type="text" class="form-control col-sm-6" aria-required="true" readonly /></div>
                    <div class="text-danger" [hidden]="fgCredits.controls.pct.valid || !fgCredits.controls.pct.touched">
                      <small *ngIf="fgCredits.controls.pct.hasError('required')">Credit type ID number is required. Use 'Search for credit' above and select the ID number</small>
                    </div>
                    <div class="text-danger"><small *ngIf="error!=''">{{error}}</small></div>
                  </div>
                </div>

                <div class="row" *ngIf="pctName!=''">
                  <div class="form-group col col-md-12 col-xs-12">
                    <label class="control-label" for="pct">Name:</label>&nbsp;{{name}}

                  </div>
                </div>

              </div>
              <div class="col col-md-6">
                <div *ngIf="isEcocredit" class="row">
                  <div class="form-group col col-md-10 col-xs-5">
                    <label class="control-label" for="vegClass">Vegetation class:</label>&nbsp;{{vegClass}}


                  </div>
                </div>
                <div *ngIf="isEcocredit" class="row">
                  <div class="form-group col col-md-10 col-xs-5">
                    <label class="control-label" for="vegFormation">Formation:</label>&nbsp;{{formation}}

                  </div>
                </div>

                <div *ngIf="isEcocredit" class="row">
                  <div class="form-group col col-md-6 col-xs-5">
                    <label class="control-label" for="pctCleared">PCT % cleared:</label>&nbsp;{{pctCleared}}

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col col-md-10 col-xs-5">
                    <span class="control-label">Threat status:</span>&nbsp;{{threatStatus}}

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col col-md-10 col-xs-5">
                    <div class="input-group">
                      <label class="control-label" for="cwOffset">EPBC Act offset :</label>
                      <span class="ml-2"><tooltip register="Common" tab="Credit Popup" section="Credit" field="EPBC Act offset"></tooltip></span>
                      <input type="checkbox" class="form-control col-sm-2" id="cwOffset" formControlName="cwOffset" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col col-md-6 col-xs-6">
                    <label class="control-label required" for="numberOfCredits">Number of credits</label>
                    <span class="ml-2"><tooltip register="Common" tab="Credit Popup" section="Credit" field="Number of credits"></tooltip></span>
                    <input id="numberOfCredits" formControlName="numberOfCredits" title="Number of credits" type="number" class="form-control" aria-required="true" />
                    <div class="text-danger" [hidden]="fgCredits.controls.numberOfCredits.valid || !fgCredits.controls.numberOfCredits.touched">
                      <small *ngIf="fgCredits.controls.numberOfCredits.hasError('required')">Number of credits are required.</small>
                      <small *ngIf="fgCredits.controls.numberOfCredits.hasError('min')">Number of credits must be greater than 0.</small>
                    </div>
                  </div>
                </div>
                <div *ngIf="isSpecies" class="row">
                  <div class="form-group col col col-md-6 col-xs-6">
                    <label class="control-label" for="speciesType">Species type:</label>&nbsp;{{speciesType}}

                  </div>
                </div>
                <!--<div *ngIf="isSpecies" class="row">
                  <div class="form-group col col col-md-12 col-sm-12">
                    <label class="control-label" for="speciesType">Offset trading group:</label>&nbsp;{{speciesOTG}}

                  </div>
                </div>-->
                <div *ngIf="isEcocredit" class="row">
                  <div class="form-group col col-md-6 col-xs-6">
                    <label class="control-label required" for="hbt">HBT</label>
                    <span class="ml-2"><tooltip register="Common" tab="Credit Popup" section="Credit" field="HBT"></tooltip></span>
                    <select id="hbt" formControlName="hbt" class="form-control">
                      <option value="">Select HBT</option>
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </select>
                    <div class="text-danger" [hidden]="fgCredits.controls.hbt.valid || !fgCredits.controls.hbt.touched">
                      <small *ngIf="fgCredits.controls.hbt.hasError('required')">HBT is required.</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="isEcocredit && mode=='A'" class="row">
              <div class="input-group">
                <div class="form-group col col-md-6">
                  <label class="control-label required" for="tradingGroup">Associated TEC</label>
                  <span class="ml-2"><tooltip register="Common" tab="Credit Popup" section="Credit" field="Associated TEC"></tooltip></span>
                  <select id="tradingGroup" formControlName="tradingGroup" class="form-control col-sm-8" (change)="tecChanged($event);">
                    <option value="">Select an offset trading group</option>
                    <option value="0" selected>No TEC</option>
                    <option *ngFor="let tradingGroup of offsetTradingGroups" value={{tradingGroup.id}}>{{tradingGroup.name}}</option>
                  </select>
   
                </div>

              </div>
            </div>
            <div class="row">
              <div class="form-group col col-12">
                <span class="control-label">Offset trading group:</span>&nbsp;{{ isEcocredit ? ecoOTG :speciesOTG}}

              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div *ngIf="!isValidOTG || !isValidHBT" class="col-12 alert alert-danger">
            <ul>
              <li *ngIf="!isValidOTG">Please select an offset trading group</li>
              <li *ngIf="!isValidHBT">Please select HBT status</li>
            </ul>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close('Cancelled')">Cancel</button>
    <button type="button" class="btn btn-primary" [disabled]="fgCredits?.invalid || error!=''" (click)="create();">{{buttonTitle}}</button>
    <span class="ml-2"><tooltip register="Common" tab="Credit Popup" section="Credit" field="Create"></tooltip></span>
  </div>
</ng-template>
<hr>




